<section>
  <div #voidDum></div>
  <div class="">
    <div class="row mb-3 py-1 border-bottom">
      <b><app-breadcrumb [Breadcrumblist]="breadCrumbList"></app-breadcrumb></b>
    </div>

    <form [formGroup]="addEditFormGroup" class="py-2" (ngSubmit)="submitForm(true)">
      <div class="row">
        <div class="row">
          <div class="col-md-5">
            <div class="row">
              <div class="mb-2 p-1" *ngIf="flashCardId">
                <span>
                  <b style="padding: 0.8em">Flash Card No: </b>
                  {{ flashCardId }}
                </span
                >
              </div>
            </div>
          </div>
          <div class="col-md-7">
            <div
              class="d-flex"
              style="
                justify-content: space-between;
                position: relative;
                left: 4.5em;
                top: -1em;
              "
            >
              <div class="row">
                <div class="col-md-6">
                  <div class="">
                    <span
                      ><b>Flash Card Status Type</b>
                      <span class="p-0 label-red">*</span></span
                    >
                    <select
                      formControlName="FlashCardStatusType"
                      class="form-control form-control-sm inputfield-txt"
                      [ngClass]="
                        getError('FlashCardStatusType')
                          ? 'red-border-required'
                          : ''
                      "
                    >
                      <option hidden>Choose Flash Card Status Type</option>
                      <option
                        class="border-bottom"
                        *ngFor="let code of flashCardStatusType"
                        [value]="code.Code"
                      >
                        {{ code.Description }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6 ">
                  <div class="d-none">
                    <span
                      ><b>Tested Concept's Difficulty Level</b>
                      <span class="p-0 label-red">*</span></span
                    >
                    <select
                      formControlName="TestedConceptDifficultyLevel"
                      class="form-control form-control-sm inputfield-txt"
                      [ngClass]="
                        getError('TestedConceptDifficultyLevel')
                          ? 'red-border-required'
                          : ''
                      "
                    >
                      <option hidden>Choose Difficulty Level</option>
                      <option
                        class="border-bottom"
                        *ngFor="let code of difficultyTypeList"
                        [value]="code.Code"
                      >
                        {{ code.Description }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6 mt-2">
                  <div>
                    <div>
                      <span
                        ><b>Created By</b>
                        <span class="p-0"> - {{ createBy }}</span>
                      </span>
                    </div>
                    <div>
                      <span
                        ><b>Creation Date</b>
                        <span class="p-0"> - {{ createDate | date }}</span>
                      </span>
                    </div>
                    <div>
                      <span
                        ><b>Updated By</b>
                        <span class="p-0"> - {{ updatedBy }}</span>
                      </span>
                    </div>
                    <div>
                      <span
                        ><b>Updating Date</b>
                        <span class="p-0"> - {{ updatingDate | date }}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mt-2 ">
                  <div class="d-none">
                    <span
                      ><b>Applicable to <span class="p-0 label-red">*</span></b>
                    </span>

                    <div formArrayName="ApplicableFor">
                      <ng-container
                        *ngFor="
                          let item of getApplicableFor()?.controls;
                          let i = index
                        "
                      >
                        <div
                          [formGroupName]="i"
                          style="position: relative; z-index: 9998"
                        >
                          <input
                            formControlName="Selected"
                            type="checkbox"
                            class="m-1"
                            [id]="i"
                          />
                          <label
                            [for]="i"
                            style="position: relative; z-index: 9998"
                            >{{ getLabelName(item) }}</label
                          >
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2" style="position: relative; top: -9em">
        <div class="col-md-6">
          <span style="font-size: 1.5em !important"><b>Front View</b></span>
        </div>
      </div>
      <div class="row mt-2" style="position: relative; top: -9em">
        <div class="" style="width: 45%">
          <editor
            formControlName="FrontText"
            [init]="tinyMceOptionFront"
            (onFocusOut)="refreshItem(elemPreviewFront, 'FrontText')"
          ></editor>
        </div>

        <div class="" style="width: 43.8%">
          <div
            class="w-100 d-flex gap-2"
            style="
              top: 5.7em;
              position: relative;
            "
          >
            <i
              class="fa fa-refresh"
              style="font-size: 1.5em !important"
              (click)="refreshItem(elemPreviewFront, 'FrontText')"
            >
            </i>
            <div
              class="d-flex gap-2 flex-wrap justify-content-between w-100"
              style="position: relative; top: -0.3em;"
            >
            <div class="d-flex gap-2">
              <div
                class=" d-flex"
                style="position: relative; z-index: 9998"
              >
                <span>
                  <button
                    class="btn btn-sm bl-btn"
                    [disabled]="imageUploadingEventFlag"
                  >
                    <span class="text-light">SAVE</span>
                  </button>
                </span>
                <span class="mx-2">
                  <button
                    #cancelElem
                    type="button"
                    class="btn btn-sm bg-light border"
                    (click)="clear()"
                  >
                    CANCEL
                  </button>
                </span>
              </div>
              <div  style="position: relative; z-index: 9998">
                <div *ngIf="flashCardId">
                  <button
                    type="button"
                    class="btn btn-sm bl-btn"
                    (click)="relocateFlashcard = true"
                  >
                    <span class="text-light">Relocate Flash Card</span>
                  </button>
                </div>
              </div>
              <div  style="position: relative; z-index: 9998">
                <div>
                  <button
                    type="button"
                    [disabled]="!flashCardId"
                    [hidden]="!flashCardId"
                    class="btn btn-sm bl-btn"
                    (click)="AssignFlashCard()"
                  >
                    <span class="text-light">Assign Flash Card</span>
                  </button>
                </div>
              </div>
            </div>
              <div
                *ngIf="flashCardId && globalFlashCardList?.length"
                style="position: relative; z-index: 9998"
              >
                <div class="d-flex gap-2">
                  <div *ngIf="true">
                    <button
                      type="button"
                      class="btn btn-sm bl-btn"
                      (click)="paginate('PRE')"
                      [hidden]="!flashCardId"
                      [disabled]="pagination.preBtnDis"
                    >
                      <span class="text-light">Previous</span>
                    </button>
                  </div>
                  <div *ngIf="true" style="position: relative;">
                    <button
                      type="button"
                      class="btn btn-sm bl-btn"
                      [hidden]="!flashCardId"
                      (click)="paginate('NXT')"
                      [disabled]="pagination.nxtBtnDis"
                      [hidden]="!flashCardId"
                    >
                      <span class="text-light">Next</span>
                    </button>
                  </div>
                </div>
              </div>
              <div
                class="col-md-3"
                *ngIf="!globalFlashCardList?.length"
                style="position: relative; z-index: 9998"
              >
                <div class="d-flex" style="justify-content: space-evenly">
                  <div *ngIf="true">
                    <button
                      type="button"
                      class="btn btn-sm bl-btn"
                      [disabled]="true"
                      [hidden]="!flashCardId"
                    >
                      <span class="text-light">Previous</span>
                    </button> 
                  </div>
                  <div *ngIf="true" style="position: relative;">
                    <button
                      type="button"
                      class="btn btn-sm bl-btn"
                      [disabled]="true"
                      [hidden]="!flashCardId"
                    >
                      <span class="text-light">Next</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            style="
              position: relative;
              top: 5.6em;
              width: 100%;
              height: 35.2em;
              border: 5px solid grey;
              overflow-y: scroll;
              overflow-x: scroll;
            "
          >
            <div
              class="font-container-preview"
              style="margin-top: 0.9em; margin-left: 0.9em"
              #elemPreviewFront
            ></div>
          </div>
        </div>
      </div>
      <div class="row mt-2" style="position: relative; top: -9em">
        <div class="col-md-6">
          <span style="font-size: 1.5em !important"><b>Back View</b></span>
        </div>
      </div>
      <div class="row my-2" style="position: relative; top: -9em">
        <div class="" style="width: 45%">
          <editor
            formControlName="BackText"
            [init]="tinyMceOptionBack"
            (onFocusOut)="refreshItem(elemPreviewBack, 'BackText')"
          ></editor>
        </div>
        <div class="" style="width: 43.8%">
          <div class="w-100 d-flex" style="top: 5.5em; position: relative">
            <i
              class="fa fa-refresh"
              style="font-size: 1.5em !important"
              (click)="refreshItem(elemPreviewBack, 'BackText')"
            >
            </i>
          </div>
          <div
            style="
              position: relative;
              top: 6.3em;
              width: 100%;
              height: 35.2em;
              border: 5px solid grey;
              overflow-y: scroll;
              overflow-x: scroll;
            "
          >
            <div
              class="font-container-preview"
              style="margin-top: 0.9em; margin-left: 0.9em"
              #elemPreviewBack
            ></div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>

<section style="position: relative; z-index: 9999">
  <div class="modal fade show Model_popup1" *ngIf="relocateFlashcard">
    <div class="modal-dialog modal-dialog-centered modal-dialog-EditRelocate">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">
            Relocate Question
          </h6>
          <button
            type="button"
            class="close"
            (click)="relocateFlashcard = false"
            style="padding-right: 20px; font-size: 30px; outline: 0"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body px-3 py-0">
          <div class="col-12 d-flex">
            <div class="pl-1 pt-1 headersize">Current Location:</div>
            <div class="pr-1 headersize">
              <app-breadcrumb
                [Breadcrumblist]="breadCrumbList"
              ></app-breadcrumb>
            </div>
          </div>
          <div class="col-12" *ngIf="relocateFlashcard === true">
            <div class="row" *ngIf="relocateFlashcard">
              <div class="col-12">
                <app-fa-relocate-question
                  (CloseEdit)="closeEdit()"
                  (CloseRelocateQuestion)="relocate($event)"
                  [flashCardId]="flashCardId"
                  [subjectById]="subjectById"
                ></app-fa-relocate-question>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
